import React from 'react';
import Layout from './Layout/Layout';
import ListProduct from './ListProduct/ListProduct';
// import axios from 'axios';
function Home(props) {
//     const [fbook,setFbook] = useState({
//         user: {},
//         er: null,
//         authenticated: false
//     });
//     const {user,er,authenticated} = fbook;

//     const fetLoginFb =()=>{
//         axios.get('/login/success',{withCredentials: true})
//         .then(data=>{
//             setFbook({...fbook,user:data.data.user,authenticated:true});
//         }).catch(err=>{
//             setFbook({er:"Failed to authenticate user",authenticated:false});
//         })
//     };
// useEffect(()=>{
//     fetLoginFb();
// },[]);

    // const showMessageFb =()=>(
    //     <div>
    //       {!authenticated ? (
    //         <h1>Welcome!{er}</h1>
    //       ) : (
    //         <div>
    //           <h1>You have login succcessfully!</h1>
    //           <h2>Welcome {user.name}!</h2>
    //         </div>
    //       )}
    //     </div>
    // )
    return (
        <React.Fragment>
            <Layout/>
            <div className="container-fluid" style={{backgroundColor:"#f7f7f7"}}>
            {/* {showMessageFb()} */}
            <ListProduct/>
            </div>
        </React.Fragment>
    );
}

export default Home;